module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isApplicationLoaded) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalApplicationAssessment"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "showOk": true,
      "okClass": "btn btn-primary",
      "closeWhenOk": true,
      "okText": "Mark Complete",
      "cancelClass": "btn btn-primary",
      "title": "Assessment Records",
      "large": ""
    },
    on: {
      "ok": function($event) {
        return _vm.completeAssessmentsToMe()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body panel-collapse collapse in"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "assessment_form",
      "method": "put"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Select licensed activities with assessment for completion")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.activitiesWithAssessment), function(a, index) {
    return _c('div', {
      key: ("a_" + index),
      staticClass: "col-sm-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedActivities),
        expression: "checkedActivities"
      }],
      attrs: {
        "type": "checkbox",
        "name": "licence_activity",
        "id": a.licence_activity
      },
      domProps: {
        "value": a.licence_activity,
        "checked": Array.isArray(_vm.checkedActivities) ? _vm._i(_vm.checkedActivities, a.licence_activity) > -1 : (_vm.checkedActivities)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedActivities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = a.licence_activity,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedActivities = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedActivities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedActivities = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(a.activity_name_str) + "\n                                            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Final Comments")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.final_comment),
      expression: "final_comment"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    },
    attrs: {
      "readonly": !_vm.canCompleteAssessment
    },
    domProps: {
      "value": (_vm.final_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.final_comment = $event.target.value
      }
    }
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.headerLabel) + ": " + _vm._s(_vm.application.lodgement_number))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                       Submission \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Submitted by")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm.application.submitter.first_name) + " " + _vm._s(_vm.application.submitter.last_name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Lodged on")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm._f("formatDate")(_vm.application.lodgement_date)) + "\n                            ")]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                        Workflow \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                                " + _vm._s(_vm.application.processing_status.name)), _c('br'), _vm._v(" "), _vm._l((_vm.licence_type_data), function(item) {
    return _c('div', {
      staticClass: "col-sm-12"
    }, _vm._l((item), function(item1) {
      return _c('div', [(item1.name) ? _c('div', [_c('strong', [_vm._v(_vm._s(item1.name) + ": ")]), _vm._v(_vm._s(item1.processing_status.name) + "\n                                        ")]) : _vm._e()])
    }), 0)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssignToAssessor),
      expression: "showAssignToAssessor"
    }],
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('strong', [_vm._v("Assigned Assessors")]), _c('br'), _vm._v(" "), _vm._l((_vm.activeAssessments), function(activity_assessment) {
    return _c('div', [(activity_assessment.assessor_group.name) ? _c('div', [_c('div', [_vm._v("Assessment for " + _vm._s(activity_assessment.assessor_group.name.split('Wildlife Compliance - Assessors:')[1]))]), _vm._v(" "), [(activity_assessment.assigned_assessor != null) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (activity_assessment.assigned_assessor.id),
        expression: "activity_assessment.assigned_assessor.id"
      }],
      ref: "assigned_assessor",
      refInFor: true,
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(activity_assessment.assigned_assessor, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((activity_assessment.assessors), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    })], 2) : _vm._e(), _vm._v(" "), (activity_assessment.assigned_assessor == null) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (activity_assessment.assigned_assessor_id),
        expression: "activity_assessment.assigned_assessor_id"
      }],
      ref: "assigned_assessor",
      refInFor: true,
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(activity_assessment, "assigned_assessor_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((activity_assessment.assessors), function(member) {
      return _c('option', {
        key: member.id,
        domProps: {
          "value": member.id
        }
      }, [_vm._v(_vm._s(member.first_name) + " " + _vm._s(member.last_name))])
    })], 2) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "actionBtn pull-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.makeMeAssessor(activity_assessment)
        }
      }
    }, [_vm._v("Assign to me")])]], 2) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.isFinalised) ? [_c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication || !this.unfinishedActivities.length) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: true,
          showFinalised: true
        })
      }
    }
  }, [_vm._v("Show Application")]) : _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: false
        })
      }
    }
  }, [_vm._v("Hide Application")])]), _vm._v(" "), _vm._m(1)])] : _vm._e(), _vm._v(" "), (_vm.isFinalised) ? [_vm._m(2)] : _vm._e(), _vm._v(" "), (!_vm.showBackToProcessingButton) ? [_c('div', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Application")]), _c('br'), _vm._v(" "), (!_vm.showingApplication) ? _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: true,
          showFinalised: false
        })
      }
    }
  }, [_vm._v("Show Application")]) : _c('a', {
    staticClass: "actionBtn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleApplication({
          show: false,
          showFinalised: false
        })
      }
    }
  }, [_vm._v("Hide Application")]), _c('br')])])] : _vm._e(), _vm._v(" "), (!_vm.showBackToProcessingButton) ? [_vm._m(4)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [(_vm.showingApplication) ? [_vm._m(5), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAssessmentConditionButton),
      expression: "showAssessmentConditionButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleAssessments()
      }
    }
  }, [_vm._v("Assessments & Conditions")]), _c('br')])])] : [_vm._m(6), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackToProcessingButton),
      expression: "showBackToProcessingButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backToProcessing()
      }
    }
  }, [_vm._v("Back to Processing")]), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRequestInspectionButton),
      expression: "showRequestInspectionButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleRequestInspection()
      }
    }
  }, [_vm._v("Request Inspection")]), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCompleteAssessmentsButton),
      expression: "showCompleteAssessmentsButton"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary top-buffer-s col-xs-12",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAssessmentModal()
      }
    }
  }, [_vm._v("Complete Assessments")]), _c('br')])])]], 2)], 2)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.applicationDetailsVisible) ? _c('ApplicationAssessments') : _vm._e(), _vm._v(" "), (_vm.applicationDetailsVisible) ? [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tabs-main"
    }
  }, _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [_c('a', {
      class: {
        'nav-link amendment-highlight': _vm.application.has_amendment
      },
      attrs: {
        "data-toggle": "pill",
        "href": '#' + _vm.activityTab
      },
      on: {
        "click": function($event) {
          return _vm.selectTab(activity)
        }
      }
    }, [_vm._v(_vm._s(activity.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.activityTab
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "action": _vm.application_form_url,
      "method": "post",
      "name": "new_application",
      "enctype": "multipart/form-data"
    }
  }, [(_vm.isApplicationLoaded) ? _c('Application', {
    attrs: {
      "form_width": "inherit",
      "withSectionsSelector": false
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrfmiddlewaretoken"
    },
    domProps: {
      "value": _vm.csrf_token
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "schema"
    },
    domProps: {
      "value": JSON.stringify(_vm.application)
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "application_id"
    },
    domProps: {
      "value": 1
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_activity_tab_id),
      expression: "selected_activity_tab_id"
    }],
    attrs: {
      "type": "hidden",
      "id": "selected_activity_tab_id"
    },
    domProps: {
      "value": (_vm.selected_activity_tab_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected_activity_tab_id = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.allCurrentActivities), function(activity, index) {
    return _c('div', [(activity.id == _vm.selected_activity_tab_id) ? _c('renderer-block', {
      key: ("renderer_block_" + index),
      attrs: {
        "component": activity
      }
    }) : _vm._e()], 1)
  }), _vm._v("\n                                            " + _vm._s(this.$slots.default) + "\n\n                                            "), (_vm.showNavBarBottom) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(!_vm.applicationIsDraft && _vm.canSaveApplication) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save Changes")]) : _vm._e()])])])])]) : _vm._e()], 2) : _vm._e()], 1)])])])])] : _vm._e(), _vm._v(" "), _c('InspectionRequest', {
    ref: "inspection",
    on: {
      "inspection-created": _vm.requestedInspection
    }
  })], 2)])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 top-buffer-s"
  }, [_c('table', {
    staticClass: "table small-table"
  }, [_c('tr', [_c('th', [_vm._v("Lodgement")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Action")]), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6976b7e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/applications/complete_assessment.vue
// module id = 1001
// module chunks = 0